var _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLucidchart(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      fill: "none"
    },
    id: "svg933",
    viewBox: "0 0 23 27",
    height: 27,
    width: 23,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs937"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f96b13"
    },
    id: "path917",
    d: "M 0,6.75488 V 20.2549 L 11.5,27 V 23.6323 L 2.875,18.5613 V 8.43873 Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#cc4e00"
    },
    id: "path919",
    d: "M 20.125,8.43873 V 21.9387 L 23,20.2549 V 6.75488 Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffca73"
    },
    id: "path921",
    d: "M 8.625,1.68385 20.125,8.43872 23,6.75487 11.5,0 Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffca73"
    },
    id: "path923",
    d: "M 0,6.75486 2.875,8.43872 5.75,6.75486 2.875,5.06128 Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#cc4e00"
    },
    id: "path925",
    d: "M 2.875,8.43873 V 18.5613 L 5.75,16.8774 V 6.75488 Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#cc4e00"
    },
    id: "path927",
    d: "M 11.5,23.6323 V 27 l 2.875,-1.6838 v -3.3775 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffca73"
    },
    id: "path929",
    d: "M 2.875,18.5613 11.5,23.6323 14.375,21.9387 5.75,16.8774 Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f96b13"
    },
    id: "path931",
    d: "m 8.625,1.68384 v 3.37743 l 8.625,5.06133 v 10.1323 l 2.875,1.6838 v -13.5 z"
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLucidchart);
export default __webpack_public_path__ + "static/media/lucidchart.05f4406ac7d2dcfa88ea1d13bfee451c.svg";
export { ForwardRef as ReactComponent };